<template>
    <div class="page_content">
        <h1 class="head_title">重修申请</h1>
        <div v-loading="loading">
            <!-- 当前可申请批次 -->
            <template v-if="canApply && currentSetting">
                <el-card class="info_card" shadow="hover">
                    <div slot="header" class="card_header">
                        <span class="title">{{ currentSetting.courseRetakeSettingName }}</span>
                        <el-tag type="success" size="small" style="margin-left: 10px;">可申请</el-tag>
                    </div>
                    <div class="info_list">
                        <div class="info_item">
                            <span class="label">年级：</span>
                            <span class="value">{{ currentSetting.grade }}</span>
                        </div>
                        <div class="info_item">
                            <span class="label">申请开始时间：</span>
                            <span class="value">{{ currentSetting.applicationStartTime }}</span>
                        </div>
                        <div class="info_item">
                            <span class="label">申请结束时间：</span>
                            <span class="value">{{ currentSetting.applicationEndTime }}</span>
                        </div>
                        <div class="info_item" v-if="!$isEmpty(currentSetting.courseRetakeSettingDescription)">
                            <span class="label">说明：</span>
                            <span class="value">{{ currentSetting.courseRetakeSettingDescription }}</span>
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="apply_action">
                        <el-button type="primary" icon="el-icon-plus" @click="openApplyDialog">申请重修</el-button>
                    </div>
                </el-card>
            </template>
            <!-- 不可申请 -->
            <el-empty v-else-if="!loading" :description="cannotApplyReason || '当前暂无可申请的重修批次'"></el-empty>
        </div>

        <!-- 我的申请列表 -->
        <div class="record_section">
            <div class="section_header">
                <h2 class="section_title">我的申请</h2>
                <el-button type="text" icon="el-icon-refresh" @click="getApplicationList">刷新</el-button>
            </div>
            <el-table :data="applicationList" v-loading="listLoading" border style="width: 100%">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column label="批次名称" min-width="180" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.courseRetakeSettingName }}</template>
                </el-table-column>
                <el-table-column label="审核状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="auditStatusType(scope.row.auditStatus)" size="small">
                            {{ auditStatusText(scope.row.auditStatus) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="课程数" width="80" align="center">
                    <template slot-scope="scope">{{ (scope.row.courseItems || []).length }}</template>
                </el-table-column>
                <el-table-column label="驳回原因" min-width="180" show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{ $isEmpty(scope.row.rejectionReason) ? '暂无' : scope.row.rejectionReason }}
                    </template>
                </el-table-column>
                <el-table-column label="审核时间" width="160" align="center">
                    <template slot-scope="scope">{{ $isEmpty(scope.row.auditTime) ? '暂无' : scope.row.auditTime }}</template>
                </el-table-column>
                <el-table-column label="提交时间" width="160" align="center">
                    <template slot-scope="scope">{{ $isEmpty(scope.row.createTime) ? '暂无' : scope.row.createTime }}</template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="viewDetail(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 申请重修对话框 -->
        <el-dialog title="申请重修" :visible.sync="applyDialogVisible" width="1000px" @close="resetApplyForm"
            :close-on-click-modal="false">
            <el-form label-width="120px" v-loading="submitLoading">
                <el-form-item label="可申请批次：">
                    <span>{{ currentSetting ? currentSetting.courseRetakeSettingName : '' }}</span>
                </el-form-item>
                <el-form-item label="选择课程：">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addCourseItem">添加课程</el-button>
                    <el-table :data="courseItems" border style="width: 100%; margin-top: 10px;">
                        <el-table-column label="课程" min-width="200" align="center">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.tePlanCourseId" placeholder="请选择课程" filterable
                                    style="width: 100%;">
                                    <el-option v-for="c in courseOptions" :key="c.tePlanCourseId"
                                        :label="c.courseName + (c.courseCode ? '（' + c.courseCode + '）' : '')"
                                        :value="c.tePlanCourseId" :disabled="isCourseSelected(c.tePlanCourseId, scope.$index)">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="重修类型" width="180" align="center">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.retakeType" placeholder="请选择" @change="onRetakeTypeChange(scope.$index)">
                                    <el-option label="网课和作业" :value="1"></el-option>
                                    <el-option label="考试" :value="2"></el-option>
                                    <el-option label="网课、作业和考试" :value="3"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="时间设置" min-width="280" align="center">
                            <template slot-scope="scope">
                                <div class="time_block" v-if="needOnline(scope.row.retakeType)">
                                    <div class="time_row">
                                        <div>
                                            <span class="time_label">网课开始：</span>
                                            <el-date-picker v-model="scope.row.onlineStartTime" type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" style="width: 200px;">
                                            </el-date-picker>
                                        </div>
                                        <div>
                                            <span class="time_label">网课结束：</span>
                                            <el-date-picker v-model="scope.row.onlineEndTime" type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" style="width: 200px;">
                                            </el-date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="time_block" v-if="needHomework(scope.row.retakeType)">
                                    <div class="time_row">
                                        <div>
                                            <span class="time_label">作业开始：</span>
                                            <el-date-picker v-model="scope.row.homeworkStartTime" type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" style="width: 200px;">
                                            </el-date-picker>
                                        </div>
                                        <div>
                                            <span class="time_label">作业结束：</span>
                                            <el-date-picker v-model="scope.row.homeworkEndTime" type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" style="width: 200px;">
                                            </el-date-picker>
                                        </div>
                                    </div>
                                </div>
                                <div class="time_block" v-if="needExam(scope.row.retakeType)">
                                    <div class="time_row">
                                        <div>
                                            <span class="time_label">考试开始：</span>
                                            <el-date-picker v-model="scope.row.examStartTime" type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" style="width: 200px;">
                                            </el-date-picker>
                                        </div>
                                        <div>
                                            <span class="time_label">考试结束：</span>
                                            <el-date-picker v-model="scope.row.examEndTime" type="datetime"
                                                value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" style="width: 200px;">
                                            </el-date-picker>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="70" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" style="color: #f56c6c;" @click="removeCourseItem(scope.$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item label="附件：">
                    <el-upload class="upload-demo" :auto-upload="false" :accept="accept"
                        :on-change="handleFileChange" :on-remove="handleFileRemove"
                        :file-list="uploadFileList" multiple>
                        <el-button size="small" type="primary">点击选择文件</el-button>
                        <div slot="tip" class="el-upload__tip">支持 {{ accept }} 等格式，单文件不超过50MB</div>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="applyDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitApply" :loading="submitLoading">提 交</el-button>
            </span>
        </el-dialog>

        <!-- 申请详情对话框 -->
        <el-dialog title="申请详情" :visible.sync="detailDialogVisible" width="1000px">
            <div v-loading="detailLoading">
                <template v-if="detailInfo">
                    <div class="detail_list">
                        <div class="detail_item">
                            <span class="label">批次名称：</span>
                            <span class="value">{{ detailInfo.courseRetakeSettingName }}</span>
                        </div>
                        <div class="detail_item">
                            <span class="label">审核状态：</span>
                            <span class="value">
                                <el-tag :type="auditStatusType(detailInfo.auditStatus)" size="small">
                                    {{ auditStatusText(detailInfo.auditStatus) }}
                                </el-tag>
                            </span>
                        </div>
                        <div class="detail_item" v-if="!$isEmpty(detailInfo.rejectionReason)">
                            <span class="label">驳回原因：</span>
                            <span class="value">{{ detailInfo.rejectionReason }}</span>
                        </div>
                        <div class="detail_item">
                            <span class="label">审核时间：</span>
                            <span class="value">{{ $isEmpty(detailInfo.auditTime) ? '暂无' : detailInfo.auditTime }}</span>
                        </div>
                        <div class="detail_item">
                            <span class="label">提交时间：</span>
                            <span class="value">{{ $isEmpty(detailInfo.createTime) ? '暂无' : detailInfo.createTime }}</span>
                        </div>
                    </div>
                    <el-divider content-position="left">课程明细</el-divider>
                    <el-table class="myTableClass" :data="detailInfo.courseItems || []" border style="width: 100%;">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column label="课程" min-width="160" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.courseName || '课程' }}</template>
                        </el-table-column>
                        <el-table-column label="重修类型" width="120" align="center">
                            <template slot-scope="scope">{{ retakeTypeText(scope.row.retakeType) }}</template>
                        </el-table-column>
                        <el-table-column label="网课时间" min-width="200" align="center">
                            <template slot-scope="scope">
                                <div style="line-height: 18px;">
                                    <span v-if="scope.row.onlineStartTime">{{ scope.row.onlineStartTime }} <br/>～ <br/>{{ scope.row.onlineEndTime }}</span>
                                    <span v-else>暂无</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="作业时间" min-width="200" align="center">
                            <template slot-scope="scope">
                                <div style="line-height: 18px;">
                                    <span v-if="scope.row.homeworkStartTime">{{ scope.row.homeworkStartTime }} <br/>～ <br/> {{ scope.row.homeworkEndTime }}</span>
                                    <span v-else>暂无</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="考试时间" min-width="200" align="center">
                            <template slot-scope="scope">
                                <div style="line-height: 18px;">
                                    <span v-if="scope.row.examStartTime">{{ scope.row.examStartTime }} <br/>～ <br/> {{ scope.row.examEndTime }}</span>
                                    <span v-else>暂无</span>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <template v-if="detailInfo.attachments && detailInfo.attachments.length > 0">
                        <el-divider content-position="left">附件</el-divider>
                        <div class="file_list">
                            <el-button type="text" icon="el-icon-document"
                                v-for="(att, idx) in detailInfo.attachments" :key="idx"
                                @click="previewFile(att.attachmentUrl, att.attachmentName)">
                                {{ att.attachmentName || ('附件' + (idx + 1)) }}
                            </el-button>
                        </div>
                    </template>
                </template>
                <el-empty v-else-if="!detailLoading" description="暂无数据"></el-empty>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "CourseRetake",
        data() {
            return {
                loading: false,
                listLoading: false,
                submitLoading: false,
                detailLoading: false,
                canApply: false,
                cannotApplyReason: '',
                currentSetting: null,
                courseOptions: [],
                applicationList: [],
                // 申请对话框
                applyDialogVisible: false,
                courseItems: [],
                uploadFileList: [],
                pendingFiles: [],
                accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.bmp,.gif",
                // 详情对话框
                detailDialogVisible: false,
                detailInfo: null,
            };
        },
        created() {
            this.checkCanApply();
            this.getApplicationList();
        },
        methods: {
            checkCanApply() {
                this.loading = true;
                this.$store.dispatch("user/courseRetakeCanApply").then((ret) => {
                    this.loading = false;
                    if (ret.code == 0 || ret.code == "0" || ret.code == 200 || ret.code == "200") {
                        this.canApply = !!ret.data;
                        if (this.canApply) {
                            this.getCurrentSetting();
                        }
                    } else {
                        this.cannotApplyReason = ret.msg || '当前不可申请';
                    }
                }).catch(() => {
                    this.loading = false;
                    this.cannotApplyReason = '查询申请状态失败';
                });
            },
            getCurrentSetting() {
                this.$store.dispatch("user/courseRetakeCurrentSetting").then((ret) => {
                    if (ret.code == 0 || ret.code == "0" || ret.code == 200 || ret.code == "200") {
                        this.currentSetting = ret.data;
                        if (!ret.data) {
                            this.canApply = false;
                        }
                    } else {
                        this.canApply = false;
                        this.cannotApplyReason = ret.msg || '当前暂无可申请批次';
                    }
                }).catch(() => {});
            },
            getApplicationList() {
                this.listLoading = true;
                this.$store.dispatch("user/courseRetakeList").then((ret) => {
                    this.listLoading = false;
                    if (ret.code == 0 || ret.code == "0" || ret.code == 200 || ret.code == "200") {
                        this.applicationList = ret.data || [];
                    }
                }).catch(() => {
                    this.listLoading = false;
                });
            },
            // 重修类型对应时间字段判断
            needOnline(type) {
                return type == 1 || type == 3;
            },
            needHomework(type) {
                return type == 1 || type == 3;
            },
            needExam(type) {
                return type == 2 || type == 3;
            },
            retakeTypeText(type) {
                const map = { 1: '网课和作业', 2: '考试', 3: '网课、作业和考试' };
                return map[type] || '未知';
            },
            auditStatusText(status) {
                const map = { 1: '审核通过', 2: '审核中', 3: '审核不通过' };
                return map[status] || '未知';
            },
            auditStatusType(status) {
                const map = { 1: 'success', 2: 'warning', 3: 'danger' };
                return map[status] || 'info';
            },
            // 申请对话框
            openApplyDialog() {
                this.resetApplyForm();
                this.applyDialogVisible = true;
                if (this.courseOptions.length == 0) {
                    this.getCourses();
                }
            },
            getCourses() {
                this.$store.dispatch("user/courseRetakeCourses").then((ret) => {
                    if (ret.code == 0 || ret.code == "0" || ret.code == 200 || ret.code == "200") {
                        this.courseOptions = ret.data || [];
                    } else {
                        this.$message.error(ret.msg || '获取可选课程失败');
                    }
                }).catch(() => {});
            },
            isCourseSelected(courseId, currentIndex) {
                return this.courseItems.some((item, idx) => idx != currentIndex && item.tePlanCourseId == courseId);
            },
            addCourseItem() {
                this.courseItems.push({
                    tePlanCourseId: null,
                    retakeType: 1,
                    onlineStartTime: '',
                    onlineEndTime: '',
                    homeworkStartTime: '',
                    homeworkEndTime: '',
                    examStartTime: '',
                    examEndTime: ''
                });
            },
            removeCourseItem(index) {
                this.courseItems.splice(index, 1);
            },
            onRetakeTypeChange(index) {
                let item = this.courseItems[index];
                if (!this.needOnline(item.retakeType)) {
                    item.onlineStartTime = '';
                    item.onlineEndTime = '';
                }
                if (!this.needHomework(item.retakeType)) {
                    item.homeworkStartTime = '';
                    item.homeworkEndTime = '';
                }
                if (!this.needExam(item.retakeType)) {
                    item.examStartTime = '';
                    item.examEndTime = '';
                }
            },
            resetApplyForm() {
                this.courseItems = [];
                this.uploadFileList = [];
                this.pendingFiles = [];
            },
            handleFileChange(file, fileList) {
                // 校验文件大小与类型
                const isLt50M = file.size / 1024 / 1024 < 50;
                if (!isLt50M) {
                    this.$message.error('上传文件大小不能超过 50MB!');
                    let idx = fileList.indexOf(file);
                    if (idx > -1) fileList.splice(idx, 1);
                    return;
                }
                if (!this.$isEmpty(this.accept)) {
                    const fileName = file.name;
                    const fileType = fileName.substring(fileName.lastIndexOf('.'));
                    if (this.accept.toUpperCase().indexOf(fileType.toUpperCase()) < 0) {
                        this.$message.warning("文件类型错误，请重新上传！");
                        let idx = fileList.indexOf(file);
                        if (idx > -1) fileList.splice(idx, 1);
                        return;
                    }
                }
                this.pendingFiles = fileList.map(item => item.raw);
            },
            handleFileRemove(file, fileList) {
                this.pendingFiles = fileList.map(item => item.raw);
            },
            validateCourseItems() {
                if (this.courseItems.length == 0) {
                    this.$message.warning('请至少添加一门课程');
                    return false;
                }
                for (let i = 0; i < this.courseItems.length; i++) {
                    let item = this.courseItems[i];
                    if (!item.tePlanCourseId) {
                        this.$message.warning('请选择第' + (i + 1) + '行课程');
                        return false;
                    }
                    if (!item.retakeType) {
                        this.$message.warning('请选择第' + (i + 1) + '行重修类型');
                        return false;
                    }
                    if (this.needOnline(item.retakeType)) {
                        // if (!item.onlineStartTime || !item.onlineEndTime) {
                        //     this.$message.warning('请完善第' + (i + 1) + '行网课时间');
                        //     return false;
                        // }
                        if (new Date(item.onlineStartTime) >= new Date(item.onlineEndTime)) {
                            this.$message.warning('第' + (i + 1) + '行网课开始时间须早于结束时间');
                            return false;
                        }
                    }
                    if (this.needHomework(item.retakeType)) {
                        // if (!item.homeworkStartTime || !item.homeworkEndTime) {
                        //     this.$message.warning('请完善第' + (i + 1) + '行作业时间');
                        //     return false;
                        // }
                        if (new Date(item.homeworkStartTime) >= new Date(item.homeworkEndTime)) {
                            this.$message.warning('第' + (i + 1) + '行作业开始时间须早于结束时间');
                            return false;
                        }
                    }
                    if (this.needExam(item.retakeType)) {
                        // if (!item.examStartTime || !item.examEndTime) {
                        //     this.$message.warning('请完善第' + (i + 1) + '行考试时间');
                        //     return false;
                        // }
                        if (new Date(item.examStartTime) >= new Date(item.examEndTime)) {
                            this.$message.warning('第' + (i + 1) + '行考试开始时间须早于结束时间');
                            return false;
                        }
                    }
                }
                return true;
            },
            submitApply() {
                if (!this.validateCourseItems()) {
                    return;
                }
                let formData = new FormData();
                formData.append("courseItemsJson", JSON.stringify(this.courseItems));
                // 添加附件，使用不同字段名 file0、file1...
                this.pendingFiles.forEach((file, idx) => {
                    formData.append("file" + idx, file);
                });
                this.submitLoading = true;
                this.$store.dispatch("user/courseRetakeApply", formData).then((ret) => {
                    this.submitLoading = false;
                    if (ret.code == 0 || ret.code == "0" || ret.code == 200 || ret.code == "200") {
                        this.$message.success('提交成功');
                        this.applyDialogVisible = false;
                        this.getApplicationList();
                    } else {
                        this.$message.error(ret.msg || '提交失败');
                    }
                }).catch(() => {
                    this.submitLoading = false;
                });
            },
            // 详情
            viewDetail(row) {
                this.detailDialogVisible = true;
                this.detailInfo = null;
                this.detailLoading = true;
                this.$store.dispatch("user/courseRetakeDetail", {
                    courseRetakeApplicationId: row.courseRetakeApplicationId
                }).then((ret) => {
                    this.detailLoading = false;
                    if (ret.code == 0 || ret.code == "0" || ret.code == 200 || ret.code == "200") {
                        this.detailInfo = ret.data;
                    } else {
                        this.$message.error(ret.msg || '获取详情失败');
                    }
                }).catch(() => {
                    this.detailLoading = false;
                });
            },
            previewFile(url, name) {
                if (this.$isEmpty(url)) {
                    this.$message.warning('暂无文件');
                    return;
                }
                this.$downLoadFile(url, name);
            }
        }
    };
</script>

<style scoped lang="less">
    .page_content {
        background-color: white;
        border-radius: 5px;
        min-height: calc(100vh - 100px);
    }
    .head_title {
        font-size: 24px;
        margin-bottom: 30px;
    }
    .info_card {
        .card_header {
            .title {
                font-size: 18px;
                font-weight: bold;
            }
        }
    }
    .info_list {
        .info_item {
            margin-bottom: 15px;
            .label {
                color: #909399;
                display: inline-block;
                width: 120px;
            }
            .value {
                color: #303133;
            }
        }
    }
    .apply_action {
        text-align: right;
    }
    .record_section {
        margin-top: 30px;
        .section_header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 15px;
            gap: 20px;
        }
        .section_title {
            font-size: 18px;
            color: #303133;
        }
    }
    .time_block {
        margin-bottom: 6px;
        .time_row {
            display: flex;
            align-items: center;
            gap: 4px;
            flex-wrap: wrap;
            .time_label {
                color: #909399;
                font-size: 12px;
                white-space: nowrap;
            }
        }
    }
    .detail_list {
        .detail_item {
            margin-bottom: 12px;
            .label {
                color: #909399;
                display: inline-block;
                width: 100px;
            }
            .value {
                color: #303133;
            }
        }
    }
    .file_list {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/CourseRetake.vue